(function paycheckTestModuleDefinition() {
    'use strict';

    angular.module('PaycheckTest', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList', 'Process', 'DocumentViewer'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function paycheckRRHHConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('paycheck-test-add', {
                    url: "/PaycheckTest/Add",
                    templateUrl: config.resourceUrl('/views/paycheck-test/paycheck-test-add.html'),
                    controller: 'PaycheckTestAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECK TEST')
                });
            }
        ]);
})();
